export const renderPolicyStatus = (status: string) => {
  switch (status) {
    case 'Cancelled for non-payment':
      return 'Falta de pagamento'
    case 'Cover no longer required':
      return 'A pedido do cliente'
    case 'Alternative product purchased':
      return 'A pedido do cliente'
    case 'Cancelled within cooling off':
      return 'Período de arrependimento'
    case 'Cancelled by Underwriter':
      return 'Por iniciativa da seguradora'
    case 'Other (administrative reason)':
      return 'Motivo administrativo'
    case 'Cover Overlapped with existing':
      return 'A pedido do cliente'
    case 'Poor service/complaint':
      return 'A pedido do cliente'
    case 'Too expensive':
      return 'A pedido do cliente'
    case 'Not known':
      return 'A pedido do cliente'
    case 'Unsuitable/misunderstood':
      return 'A pedido do cliente'
    default:
      return status
  }
}
